import { EMPTY_VALUE } from "./format";

const TRANSACTION_STATUS_META = {
  succeeded: { label: "Confirmada", className: "badge-success" },
  failed: { label: "Não autorizada", className: "badge-error" },
  canceled: { label: "Cancelada", className: "badge-error" },
  pre_authorized: { label: "Pré Autorizada", className: "yellow" },
  reversed: { label: "Revertida", className: "yellow" },
  refunded: { label: "Estornado", className: "blue" },
  partial_refunded: { label: "Estornado Parcialmente", className: "blue" },
  pending: { label: "Pendente", className: "orange" },
  new: { label: "Nova", className: "blue" },
  created: { label: "Recém Criado", className: "blue" },
  dispute: { label: "Em Disputa", className: "badge-error" },
  charged_back: { label: "Chargeback", className: "blue" },
};

export const transactionStatusMeta = (status) =>
  TRANSACTION_STATUS_META[status] || { label: "Indefinido", className: "black" };

export const TRANSACTION_STATUS_OPTIONS = Object.entries(TRANSACTION_STATUS_META).map(
  ([value, meta]) => ({ value, label: meta.label })
);

const PAYMENT_TYPE_LABELS = {
  credit: "Crédito",
  debit: "Débito",
  pix: "Pix",
  boleto: "Boleto",
};

export const paymentTypeLabel = (paymentType) =>
  PAYMENT_TYPE_LABELS[paymentType] || "Desconhecido";

const CAPTURE_METHOD_LABELS = {
  pos: "Venda Presencial",
  online: "Venda Digitada",
};

export const captureMethodLabel = (captureMethod) =>
  CAPTURE_METHOD_LABELS[captureMethod] || EMPTY_VALUE;

const AUTO_SPLIT_STATUS_LABELS = {
  WAITING: "Aguardando",
  PROCESSING: "Processando",
  CREATED: "Criado",
  ALREADY_EXISTENT: "Já existente",
  ALREADY_PROCESSED: "Já processado",
  NOT_SUPPORTED: "Não suportado",
  NO_SPLIT_PLAN: "Sem plano de split",
  ERROR: "Erro",
};

export const autoSplitStatusLabel = (status) =>
  AUTO_SPLIT_STATUS_LABELS[status] || status || EMPTY_VALUE;

const ACQUIRER_BADGE = {
  zoop: { letter: "Z", label: "Zoop", className: "orange" },
  deltapag: { letter: "D", label: "DeltaPag", className: "blue" },
};

export const acquirerBadge = (acquirer) => ACQUIRER_BADGE[acquirer] || null;

export const ACQUIRER_OPTIONS = Object.entries(ACQUIRER_BADGE).map(
  ([value, meta]) => ({ value, label: meta.label })
);

const NO_CARD_BRAND = "none";

export const cardBrandLabel = (brand) => {
  const value = (brand ?? "").toString().trim().toLowerCase();
  if (!value || value === NO_CARD_BRAND) {
    return "";
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
};
